import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import { parse } from 'mathjs';
import Papa from 'papaparse';
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx';

export const toastText = (
	message: string,
	type: 'success' | 'error' | 'info'
) => {
	switch (type) {
		case 'success':
			toast.success(message, {
				style: {
					fontSize: '16px',
				},
			});

			break;

		case 'error':
			toast.error(message, {
				style: {
					fontSize: '16px',
				},
			});
			break;
		case 'info':
			toast(message, {
				style: {
					fontSize: '16px',
					backgroundColor: '#f0f8ff',
					color: '#000',
				},
			});
			break;
	}
};
export const paymentOptions = [
	{
		label: 'All Status',
		value: '',
	},
	{
		label: 'Success',
		value: 'SUCCESS',
	},
	{
		label: 'Pending',
		value: 'PENDING',
	},
	{
		label: 'Failed',
		value: 'FAILED',
	},
	{
		label: 'Processing',
		value: 'PROCESSING',
	},
];
export function invalidText(value: string | number | null | undefined) {
	return (
		value === null ||
		value === undefined ||
		value.toString().trim().length === 0
	);
}

export function base64ToBlob(base64: string, mime: string) {
	const byteCharacters = atob(base64);
	const arrayBuffer = new ArrayBuffer(byteCharacters.length);
	const uint8Array = new Uint8Array(arrayBuffer);
	for (let i = 0; i < byteCharacters.length; i++) {
		uint8Array[i] = byteCharacters.charCodeAt(i);
	}
	return new Blob([uint8Array], { type: mime });
}

export const formatPhoneNumber = (phoneNumber: string) => {
	// Remove all non-numeric characters from the input
	const cleanedNumber = phoneNumber.replace(/\D/g, '');

	// Define the phone number format (e.g., "(XXX) XXX-XXXX")
	const format = '($1) $2-$3';

	// Apply the mask to the cleaned number using a regular expression
	const maskedNumber = cleanedNumber.replace(/(\d{3})(\d{3})(\d{4})/, format);

	return maskedNumber;
};

export const phoneNumberFormatHandler = (phoneNumber: any = '') => {
	const inputPhoneNumber = phoneNumber?.replace(/\D/g, ''); // Remove non-digit characters
	let formattedPhoneNumber = '';

	if (inputPhoneNumber.length > 0) {
		formattedPhoneNumber = `(${inputPhoneNumber.slice(0, 3)}`;

		if (inputPhoneNumber.length >= 4) {
			formattedPhoneNumber += `) ${inputPhoneNumber.slice(3, 6)}`;
		}

		if (inputPhoneNumber.length >= 7) {
			formattedPhoneNumber += `-${inputPhoneNumber.slice(6, 10)}`;
		}
	}

	return formattedPhoneNumber;
};

export const getPermissionObject = (
	permissionObj: any,
	allPermissions: any
) => {
	let formattedArray: any = [];
	const updatedAllPermission = allPermissions.map((singlePermission: any) => {
		return {
			...singlePermission,
			isBold: false,
		};
	});

	// const updatedPermissionObj = []
	for (const singlePermissionObj of permissionObj) {
		let tempArray = [];
		if (singlePermissionObj.name) {
			tempArray.push({
				moduleName: singlePermissionObj.name,
				isBold: true,
			});
		}

		const filteredPermissions = updatedAllPermission.filter(
			(singlePermission: any) => {
				return singlePermissionObj.items.includes(
					singlePermission.sortId
				);
			}
		);
		tempArray = [...tempArray, ...filteredPermissions];
		formattedArray = [...formattedArray, ...tempArray];
	}

	return formattedArray;
};

export const checkPermission = (
	allPermissions: any,
	requiredPermission: any
) => {
	if (!allPermissions) {
		return false;
	}
	const permissionsList = allPermissions;
	const permission = permissionsList?.find(
		(singlePermission: any) =>
			singlePermission.moduleName === requiredPermission.permissionName
	);

	if (permission) {
		const permitted = requiredPermission.permission.some(
			(singlePermission: string) => permission[singlePermission]
		);
		return permitted || permission['all'];
	} else {
		return false;
	}
};

export const permissionObject = [
	{
		items: [1, 2, 36],
	},
	{
		name: 'Employee',
		items: [3, 3.1, 4, 5, 7, 7.01, 7.02],
	},
	{
		name: 'Leave Request',
		items: [7.5],
	},
	{
		name: 'Time Activities',
		items: [7.6, 7.2, 7.3, 7.7],
	},
	{
		name: 'Payroll Settings',
		// items: [12, 19.2, 19.3, 17, 13, 19.1, 14, 18, 19, 19.4, 19.5],
		items: [12, 19.2, 19.3, 17, 13, 19.6, 19.1, 14, 19.4, 19.5],
	},
	{
		name: 'Approvals',
		// items: [9, 10, 11],
		items: [9],
	},
	{
		name: 'Payroll',
		items: [23, 24, 25, 26],
	},
	{
		name: 'Configurations',
		items: [27, 27.1, 28, 28.1, 29, 30, 31,33],
	},
	{
		name: 'Reports',
		items: [20, 21, 22],
	},
	{
		name: 'Payroll Payments',
		items: [34, 35, 25.1],
	},
];

export const PermissionDataSource: any = [
	{
		moduleName: 'Basic & Personal Details',
		sortId: 1,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Salary Details',
		sortId: 2,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Employee Payment Information',
		sortId: 3,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Employee Loan',
		sortId: 4,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Employee Declarations',
		sortId: 5,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Run Payroll',
		sortId: 6,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Reimbursements',
		sortId: 7,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Proof Of Investments',
		sortId: 8,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Salary Revision',
		sortId: 9,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Branch Code',
		sortId: 10,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Departments',
		sortId: 11,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Job Title',
		sortId: 12,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Payment Type',
		sortId: 13,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Payment Method',
		sortId: 14,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Earning',
		sortId: 16,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Deduction',
		sortId: 17,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Payroll Reports',
		sortId: 18,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Earning and Deduction Reports',
		sortId: 19,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Tax Reports',
		sortId: 20,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
	{
		moduleName: 'Payroll Payments',
		sortId: 21,
		all: false,
		view: false,
		edit: false,
		delete: false,
		add: false,
	},
];

export function validateFormData(
	dataObj: { [key: string]: any },
	errObj: { [key: string]: boolean }
): { [key: string]: boolean } {
	Object.keys(dataObj).forEach((key) => {
		if (Object.hasOwn(errObj, key)) {
			errObj[key] = invalidText(dataObj[key]);
		}
	});

	return errObj;
}

export function hasFormError(errObj: { [key: string]: boolean }): boolean {
	return Object.keys(errObj).some((key) => {
		return errObj[key];
	});
}
export const configurationModules = [
	'branch code',
	'category code',
	'company',
	'departments',
	'job grade',
	'cost center',
	'holidays',
	'leave type',
];
export const payrollSettingsModules = [
	'company setup',
	'pay period',
	'pay schedule',
	'payroll history',
	'statutory components',
	'mid-month pay',
	'deduction code',
	'earning code',
];
export function getAllowedPermissions(modules: any) {
	let allowedPermissions: any = [];

	let allowConfiguration = false;
	let allowPayrollSettings = false;
	modules?.forEach((module: any) => {
		const { moduleName, add, view, edit, approval, delete: del } = module;

		const _moduleName =
			moduleName.split(' ').length > 1
				? moduleName.split(' ')?.join('_')
				: moduleName;
		if (add) {
			allowedPermissions.push(`Add_${_moduleName}`);
		}
		if (edit) {
			allowedPermissions.push(`Edit_${_moduleName}`);
		}
		if (del) {
			allowedPermissions.push(`Delete_${_moduleName}`);
		}
		if (view) {
			allowedPermissions.push(`View_${_moduleName}`);
		}
		if (approval) {
			allowedPermissions.push(`Approval_${_moduleName}`);
		}
		if (add || view || edit || del || approval) {
			allowedPermissions.push(`Allow_${_moduleName}`);
		}
		if (
			configurationModules.includes(moduleName.toLowerCase()) &&
			(add || view || edit || del || approval)
		) {
			allowConfiguration = true;
		}
		if (
			payrollSettingsModules.includes(moduleName.toLowerCase()) &&
			(add || view || edit || del || approval)
		) {
			allowPayrollSettings = true;
		}
	});
	if (allowPayrollSettings) {
		allowedPermissions.push(`Allow_Payroll_Settings`);
	}
	if (allowConfiguration) {
		allowedPermissions.push(`Allow_Configuration`);
	}

	return allowedPermissions;
}

export function getAllowedModule(permissions: any, modules: any) {
	let _moduleName = null;
	for (let module of modules) {
		const _module = permissions.find(
			(per: any) => per.moduleName === module
		);

		if (_module) {
			const {
				moduleName,
				add,
				view,
				edit,
				approval,
				delete: del,
			} = _module;

			if (add || view || edit || del || approval) {
				_moduleName = moduleName;
				break;
			}
		}
	}

	return _moduleName;
}

export function formatChanges(changes: any) {
	if (!changes || typeof changes !== 'object') {
		throw new Error('Invalid input: changes must be an object');
	}

	// Destructure the message property from the changes object
	const { message } = changes;
	if (!message || typeof message !== 'object') {
		throw new Error('Invalid input: changes.message must be an object');
	}

	// Map over the entries of the message object and create a formatted string for each change
	const formattedChanges = Object.entries(message)
		.map(([field, item]: any) => {
			let oldValue = item?.oldValue;
			let newValue = item?.newValue;
			const isSalaryAdjusted = item?.isSalaryAdjusted;
			if (
				field === 'dateOfBirth' ||
				field === 'joiningDate' ||
				field === 'terminationDate'
			) {
				if (oldValue && oldValue !== 'NA') {
					oldValue = dayjs(oldValue).format('DD/MM/YYYY');
					newValue = dayjs(newValue).format('DD/MM/YYYY');
				} else {
					oldValue = 'NA';
					newValue = dayjs(newValue).format('DD/MM/YYYY');
				}
			}

			if (item.isSelectField) {
				oldValue = item?.oldValueName;
				newValue = item?.newValueName;
			}

			return `${
				fieldNameMapping[field as keyof typeof fieldNameMapping]
			} <span class="color-purple">from </span> ${oldValue} <span class="color-purple">to</span> ${newValue} ${
				isSalaryAdjusted
					? '<span class="color-purple">(Payroll Adjustment)</span>'
					: ''
			}`;
		})
		.join('<span class="color-purple">, </span> ');

	return formattedChanges;
}

/** Reusable: get list of changed items for default earnings/deductions (description, old/new amount, old/new checked). */
export function getDefaultEarningsOrDeductionsChangeList(
	oldVal: any[],
	newVal: any[]
): {
	description: string;
	oldAmount: string;
	newAmount: string;
	oldChecked: boolean;
	newChecked: boolean;
}[] {
	const oldByDesc = new Map(
		(oldVal || []).map((x: any) => [x.description ?? x.id ?? '', x])
	);
	const newByDesc = new Map(
		(newVal || []).map((x: any) => [x.description ?? x.id ?? '', x])
	);
	const allDescs = Array.from(
		new Set([
			...Array.from(oldByDesc.keys()),
			...Array.from(newByDesc.keys()),
		])
	);
	const changes: {
		description: string;
		oldAmount: string;
		newAmount: string;
		oldChecked: boolean;
		newChecked: boolean;
	}[] = [];
	for (const desc of allDescs) {
		if (!desc) continue;
		const oldItem = oldByDesc.get(desc);
		const newItem = newByDesc.get(desc);
		const oldAmount =
			oldItem?.amount != null ? String(oldItem.amount) : '—';
		const newAmount =
			newItem?.amount != null ? String(newItem.amount) : '—';
		const oldChecked = oldItem?.isChecked ?? false;
		const newChecked = newItem?.isChecked ?? false;
		if (oldAmount !== newAmount || oldChecked !== newChecked) {
			changes.push({
				description: desc,
				oldAmount,
				newAmount,
				oldChecked,
				newChecked,
			});
		}
	}
	return changes;
}

export const fieldNameMapping = {
	firstName: 'First Name',
	lastName: 'Last Name',
	dateOfBirth: 'Date of Birth',
	gender: 'Gender',
	country: 'Country',
	maritalStatus: 'Marital Status',
	joiningDate: 'Joining Date',
	branchId: 'Branch Code',
	branch: 'Branch Code',
	departmentId: 'Department',
	department: 'Department',
	costCenterId: 'Cost Center',
	costCenter: 'Cost Center',
	categoryId: 'Category',
	category: 'Category',
	jobGradeId: 'Job Title',
	jobGrade: 'Job Title',
	staffCode: 'Staff Code',
	ssn: 'SSN',
	passportNo: 'Passport Number',
	nationalRegistrationNo: 'National Registration Number',
	recordStatus: 'Record Status',
	employeeTPIN: 'Employee TPIN',
	currency: 'Currency',
	taxationMethod: 'Taxation Method',
	employmentType: 'Employment Type',
	isCompensationFund: 'Is Compensation Fund',
	napsaPaidBy: 'NAPSA Paid By',
	enableGrossUpTax: 'Enable Gross Up Tax',
	disabilities: 'Disabilities',
	grossUpAllEarnings: 'Gross Up All Earnings',
	terminationDate: 'Termination Date',
	earnings: 'Earnings',
	monthlySalary: 'Monthly Salary',
	hourlySalary: 'Hourly Salary',
	midMonthSalary: 'Mid Month Salary',
	effectiveStartDate: 'Effective Date',
	notes: 'Notes',
	'Salary Details': 'Monthly Salary',
	supervisorIds: 'Supervisor',
	location: 'Location',
	name: 'Name',
	description: 'Description',
	maximumLeavePerMonth: 'Maximum Leave Per Month',
	attachmentRequired: 'Attachment Required',
	leaveEncashment: 'Leave Encashment',
	percentageOfDeduction: 'Percentage of Deduction',
	amount: 'Amount',
	formula: 'Formula',
	holidayName: 'Holiday Name',
	holidayDate: 'Holiday Date',
	code: 'Code',
	accNo: 'Account Number',
	seqNo: 'Sequence Number',
	percent: 'Percent',
	function: 'Function',
	displayName: 'Name',
	shiftName: 'Shift Name',
	startTime: 'Start Time',
	endTime: 'End Time',
	startDate: 'Start Date',
	endDate: 'End Date',
	isNightShift: 'Night Shift',
	defaultRegularHours: 'Default Regular Hours',
	defaultOverTimeHours: 'Default Overtime Hours',
	employeeIds: 'Employee Details',
	isForeManShift: 'Foreman Shift',
	isExtraEarning: 'Extra Earnings',
	isThirdPartyLoanDeduction: 'Third Party Loan',
	defaultEarnings: 'Master Earnings',
	defaultDeductions: 'Master Deductions',
};

export const sectionMapping = {
	PERSONAL_DETAILS: 'Personal Details',
	TAXATION_DETAILS: 'Taxation Details',
	EMPLOYEE_DETAILS: 'Employee Details',
	IDENTIFICATION_DETAILS: 'Identification Details',
	EARNINGS: 'Earnings',
	DEDUCTION: 'Deduction',
	SALARY_DETAILS: 'Salary Details',
	LEAVE_MANAGEMENT: 'Leave Type',
	DEDUCTION_CODE: 'Deduction Code',
	HOLIDAY: 'Holiday',
	EARNING_CODE: 'Earning Codes',
	TIME_SHIFT: 'Time Shift',
};

export const taxationMethodMapping = {
	CONTRIBUTE_TO_CHARITY: 'Contribute to Charity',
	CUMULATIVE_BASIS: 'Cumulative Basis',
	DAILY_TAX: 'Daily Tax',
	TAX_EXEMPT: 'Tax Exempt',
};

export function formatToDateOnly(date: any) {
	// Convert to Day.js object and set the time to 00:00:00
	const dateOnly = dayjs(date).startOf('day');
	// Format to date-only string (e.g., 'YYYY-MM-DD')
	return dateOnly.format('YYYY-MM-DD');
}
export const removeEmptyValues = (obj: any) => {
	return Object.fromEntries(
		Object.entries(obj).filter(
			([_, value]) => value !== null && value !== undefined
		)
	);
};

export function extractVariables(node: any, variables = new Set<string>()) {
	if (node.isSymbolNode) {
		variables.add(node.name);
	} else if (node.args) {
		node.args.forEach((arg: any) => extractVariables(arg, variables));
	}

	return Array.from(variables); // Convert Set to an array using Array.from()
}
// export const validateFormula = (
// 	formula: string,
// 	allowedVariables: string[]
// ): boolean => {
// 	try {
// 		const node = parse(formula);
// 		const variables = extractVariables(node);
// 		if (Number(formula) === 0) {
// 			return false;
// 		}
// 		for (const variable of variables) {
// 			if (!allowedVariables.includes(variable)) {
// 				return false;
// 			}
// 		}

// 		return true;
// 	} catch (error) {
// 		return false;
// 	}
// };

export const validateFormula = (
	formula: string,
	allowedVariables: string[]
): boolean => {
	try {
		if (!isNaN(Number(formula)) && Number(formula) === 0) {
			return false;
		}
		const node = parse(formula);
		const variables = extractVariables(node);
		for (const variable of variables) {
			if (!allowedVariables.includes(variable)) {
				return false;
			}
		}
		return true;
	} catch (error) {
		return false;
	}
};
export const allowedVariablesForEarningsFormula = [
	'SAL',
	'OTH',
	'BSP',
	'LVD',
	'NMW',
	'SDH',
	'NDW',
	'MMA',
];

export function timeStringToMinutes(timeString: string) {
	const [hours, minutes] =
		!invalidText(timeString) && timeString?.includes(':')
			? timeString.split(':').map(Number)
			: [0, 0];
	return hours * 60 + minutes;
}

export function minutesToTimeString(totalMinutes: number) {
	const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
	const minutes = String(totalMinutes % 60).padStart(2, '0');
	return `${hours}:${minutes}`;
}

export function checkHoliday(date: Date, holidays: any[]): boolean {
	return holidays.find((holiday) => {
		const _holidayDate = new Date(holiday.holidayDate);
		const _date = new Date(date);

		_holidayDate.setHours(0, 0, 0, 0);
		_date.setHours(0, 0, 0, 0);

		return _holidayDate.getTime() === _date.getTime();
	});
}

export function formatNumber(
	number: number,
	data: any,
	isUsd?: boolean,
	isCurrency: boolean = true
) {
	let currency;
	if (isUsd) {
		currency = data?.find((item: any) => item.currency === 'USD');
	} else {
		currency = data?.find((item: any) => item.currency === 'ZMW');
	}

	if (invalidText(currency)) {
		return number;
	}

	const {
		currencyPosition,
		decimalSeparator,
		displayFormat,
		negativeDisplay,
		symbol,
		thousandSeparator,
	} = currency;

	// Helper function to format numbers with commas (1,234,567) or Indian format (12,34,567)
	const formatWithSeparator = (num: any, separator: any, format: any) => {
		if (format === 1) {
			// Standard format: 1,234,567
			return num.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
		} else if (format === 2) {
			// Indian format: 12,34,567
			let x = num.split('.');
			let lastThree = x[0].slice(-3);
			let otherNumbers = x[0].slice(0, -3);
			if (otherNumbers !== '') {
				lastThree = separator + lastThree;
			}
			otherNumbers = otherNumbers.replace(
				/\B(?=(\d{2})+(?!\d))/g,
				separator
			);
			x[0] = otherNumbers + lastThree;
			return x.join('.');
		}
		return num;
	};

	// Determine if number is negative and handle accordingly
	let isNegative = number < 0;
	let absNumber = Math.abs(number).toFixed(decimalSeparator);

	// Use the correct thousand separator
	let separator = thousandSeparator === 'COMA' ? ',' : '.';

	// Split the number to handle the decimal part separately
	let [wholePart, decimalPart] = absNumber.split('.');

	// Format the whole number part based on displayFormat
	let formattedNumber = formatWithSeparator(
		wholePart,
		separator,
		displayFormat
	);

	// Add decimal part if applicable
	if (decimalPart) {
		formattedNumber += '.' + decimalPart;
	}

	// Handle negative numbers display
	if (isNegative) {
		if (negativeDisplay === 'MINUS') {
			formattedNumber = `-${formattedNumber}`;
		} else if (negativeDisplay === 'BRACKETS') {
			formattedNumber = `(${formattedNumber})`;
		}
	}

	// Handle currency position
	if (isCurrency) {
		if (currencyPosition === 'BEFORE') {
			formattedNumber = `${symbol} ${formattedNumber}`;
		} else if (currencyPosition === 'AFTER') {
			formattedNumber = `${formattedNumber} ${symbol}`;
		}
	}

	return formattedNumber;
}

export const payPeriodNameFn = (startDate: string, endDate: string) => {
	const start = dayjs(startDate, 'DD-MM-YYYY');
	const end = dayjs(endDate, 'DD-MM-YYYY');

	const startMonthEnd = start.endOf('month');
	const daysInStartMonth = startMonthEnd.isBefore(end)
		? startMonthEnd.diff(start, 'day') + 1
		: end.diff(start, 'day') + 1;

	const endMonthStart = end.startOf('month');
	const daysInEndMonth = end.diff(endMonthStart, 'day') + 1;

	const hasMoreDaysInStartMonth = daysInStartMonth > daysInEndMonth;
	const dominantMonth = hasMoreDaysInStartMonth
		? start.format('MMMM')
		: end.format('MMMM');

	return `${dominantMonth} (${start.format('DD/MM/YYYY')} - ${end.format(
		'DD/MM/YYYY'
	)})`;
};

export const getFinancialYearEndMonth = (financialYearStartMonth: number) => {
	return financialYearStartMonth === 1 ? 12 : financialYearStartMonth - 1;
};

export const getFinancialYearRange = (year: number, month: number) => {
	const startDate = dayjs().year(year).month(month).startOf('month');
	const endDate = startDate.add(1, 'year').subtract(1, 'day').endOf('month');
	const formattedStartDate = startDate.format('MMMM YYYY');
	const formattedEndDate = endDate.format('MMMM YYYY');

	return `${formattedStartDate} - ${formattedEndDate}`;
};

export const capitalizeFirstLetter = (text: string) => {
	if (!text) return '';
	return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const formatWorkWeek = (workWeek: string[]) => {
	return workWeek.map((day) => capitalizeFirstLetter(day)).join(', ');
};

export const formatWorkWeekForEdit = (workWeek: string[]) => {
	return workWeek.map((day) => capitalizeFirstLetter(day)).join(',');
};

export const generatePayPeriodsForFinancialYear = (
	payPeriodData: any,
	isEdit: boolean
): any[] => {
	const {
		year,
		payrollStartDate,
		payrollEndDate,
		FinancialYearRange,
		financialMonth,
		workWeek,
	} = payPeriodData;

	const allPayPeriodData: any[] = [];

	// Extract the day of month for the start and end dates
	const endDay = dayjs(payrollEndDate).date();

	// Determine the number of iterations based on edit mode
	const _startMonth = new Date(payrollStartDate).getMonth();
	const loopIteration = isEdit ? 12 - _startMonth + financialMonth : 12;

	// Set the initial month and year for the loop
	let currentMonth = isEdit ? _startMonth : financialMonth;

	// For the first pay period, use the exact dates provided
	let firstPayPeriodStart = dayjs(payrollStartDate);
	let firstPayPeriodEnd = dayjs(payrollEndDate);

	for (let count = 0; count < loopIteration; count++) {
		let startDate, endDate;

		if (count === 0) {
			// For the first pay period, use the exact dates provided
			startDate = firstPayPeriodStart;
			endDate = firstPayPeriodEnd;
		} else {
			// For subsequent periods, start date is one day after previous end date
			const prevEndDate = dayjs(
				allPayPeriodData[count - 1].payrollEndDate
			);
			startDate = prevEndDate.add(1, 'day');

			// End date is the same day of month in the current month
			const targetMonth = startDate.month();
			const targetYear = startDate.year();

			// Get days in the target month
			const daysInTargetMonth = dayjs(
				`${targetYear}-${targetMonth + 1}-01`
			).daysInMonth();

			// Use the same day as the original end date or last day of month if that day doesn't exist
			const validEndDay = Math.min(endDay, daysInTargetMonth);
			endDate = dayjs(`${targetYear}-${targetMonth + 1}-${validEndDay}`);

			// If end date is before start date, move to next month
			if (endDate.isBefore(startDate)) {
				const nextMonth = (targetMonth + 1) % 12;
				const nextYear = nextMonth === 0 ? targetYear + 1 : targetYear;
				const daysInNextMonth = dayjs(
					`${nextYear}-${nextMonth + 1}-01`
				).daysInMonth();
				const nextValidEndDay = Math.min(endDay, daysInNextMonth);
				endDate = dayjs(
					`${nextYear}-${nextMonth + 1}-${nextValidEndDay}`
				);
			}
		}

		allPayPeriodData.push({
			year: year,
			payrollStartDate: startDate.format('YYYY-MM-DD'),
			payrollEndDate: endDate.format('YYYY-MM-DD'),
			financialYearRange: FinancialYearRange,
			financialMonth: financialMonth,
			workWeek: formatWorkWeek(workWeek),
			payPeriodName: payPeriodNameFn(
				startDate.format('DD-MM-YYYY'),
				endDate.format('DD-MM-YYYY')
			),
			sortId: count,
		});

		// Increment month for the next iteration
		currentMonth++;
		if (currentMonth > 11) {
			currentMonth = 0;
		}
	}

	return allPayPeriodData;
};

export function isSameArray(array1: any, array2: any) {
	const differencesInArray1 = array1.filter(
		(value: any) => !array2.includes(value)
	);

	const differencesInArray2 = array2.filter(
		(value: any) => !array1.includes(value)
	);

	if (differencesInArray1.length > 0 || differencesInArray2.length > 0) {
		return false;
	}
	return true;
}

export function decrypt(encryptedData: any, key: string) {
	if (invalidText(encryptedData)) {
		return '';
	}
	let [iv, encryptedText] = encryptedData.split(':');
	iv = CryptoJS.enc.Hex.parse(iv);
	let decrypted = CryptoJS.AES.decrypt(
		CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(encryptedText)),
		CryptoJS.enc.Utf8.parse(key),
		{ iv: iv, mode: CryptoJS.mode.CBC }
	);
	return decrypted?.toString(CryptoJS.enc.Utf8);
}

export const formatEntityName = (entityName: string): string => {
	if (!entityName) return '';
	return entityName
		.replace(/Details$/, '')
		.replace(/([a-z])([A-Z])/g, '$1 $2')
		.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const notificationModuleMapping = {
	EMPLOYEE: 'Employee',
	TAXATION: 'Taxation',
	SALARY: 'Salary',
	BRANCH_CODE: 'Branch Code',
	CATEGORY_CODE: 'Category Code',
	DEPARTMENT: 'Department',
	COST_CENTER: 'Cost-Center',
	JOB_GRADE: 'Job Title',
	LEAVE_MANAGEMENT: 'Leave Type',
	HOLIDAYS: 'Holidays',
	PAY_PERIOD: 'Pay-Period',
	PAY_GROUP: 'Pay-Group',
	STATUTORY_COMPONENTS: 'Statutory Components',
	EARNINGS: 'Earnings',
	DEDUCTIONS: 'Deductions',
	MID_MONTH_PAY: 'Mid-Month Pay',
	TIME_SHIFT: 'Time Shift',
	TIME_LOGS: 'Time Logs',
	TIME_SHEETS: 'Time Sheets',
	LEAVE_REQUEST: 'Leave Request',
};

export const calculateAge = (dob: string) => {
	const _dob = new Date(dob);
	const today = new Date();
	const diff = today.getTime() - _dob.getTime();
	const age = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
	return age;
};

export function capitalizeWords(str: string): string {
	if (str === 'NAPSA' || str === 'NHIMA' || str === 'PAYE') {
		return str;
	}
	return str
		.split(' ')
		.map(
			(word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
		)
		.join(' ');
}

export const convertArrayToCSV = (data: any) => {
	if (!data?.length) {
		return '';
	}

	return Papa.unparse(data, {
		// Configuration options
		quotes: true, // Quote all fields
		header: true, // Include header row
		skipEmptyLines: true,
		// You can add more Papa.unparse options here
	});
};

export const convertArrayToExcel = (data: any): Blob => {
	if (!data?.length) {
		throw new Error('No data provided');
	}

	// Create a new workbook
	const workbook = XLSX.utils.book_new();
	
	// Convert array of objects to worksheet
	const worksheet = XLSX.utils.json_to_sheet(data);
	
	// Add worksheet to workbook
	XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
	
	// Write workbook to buffer in xlsx format
	const excelBuffer = XLSX.write(workbook, { 
		type: 'array', 
		bookType: 'xlsx' 
	});
	
	// Return as Blob
	return new Blob([excelBuffer], { 
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
	});
};

export const formatDate = (date: Date, formatType: any) => {
	const formattedDate = dayjs(date).format(formatType);
	return formattedDate;
};

// Constants moved outside component to prevent recreation
export const BANK_NAME_OPTIONS = [
	{
		value: 'ABSA_BANK_ZAMBIA',
		label: 'Absa Bank Zambia Ltd',
		sortCode: '020001',
		beneficiaryCode: 'BARCZMLX',
		branchName: 'Head Office',
	},
	{
		value: 'ZANACO',
		label: 'Zambia National Commercial Bank (Zanaco)',
		sortCode: '010001',
		beneficiaryCode: 'ZNCOZMLU',
		branchName: 'Head Office',
	},
	{
		value: 'STANBIC_BANK',
		label: 'Stanbic Bank Zambia Ltd',
		sortCode: '040206',
		beneficiaryCode: 'SBICZMLX',
		branchName: 'Kitwe',
	},
	{
		value: 'INDO_ZAMBIA_BANK',
		label: 'Indo‑Zambia Bank Ltd',
		sortCode: '090000',
		beneficiaryCode: 'INZAZMLX',
		branchName: 'Head Office',
	},
	{
		value: 'STANDARD_CHARTERED',
		label: 'Standard Chartered Bank Zambia Plc',
		sortCode: null,
		beneficiaryCode: 'SCBLZMLX',
		branchName: 'Zambia',
	},
	{
		value: 'ACCESS_BANK',
		label: 'Access Bank Zambia Ltd',
		sortCode: '350000',
		beneficiaryCode: 'AZAMZMLU',
		branchName: 'Head Office',
	},
	{
		value: 'ECOBANK',
		label: 'Ecobank Zambia Ltd',
		sortCode: '360001',
		beneficiaryCode: 'ECOCZMLU',
		branchName: 'Head Office',
	},
	{
		value: 'FIRST_ALLIANCE_BANK',
		label: 'First Alliance Bank Zambia Ltd (FAB)',
		sortCode: '340005',
		beneficiaryCode: 'FALLZMLU',
		branchName: 'Lusaka Head Office',
	},
	{
		value: 'FIRST_CAPITAL_BANK',
		label: 'First Capital Bank Zambia Ltd (FCB)',
		sortCode: '280000',
		beneficiaryCode: 'FRCGZMLU',
		branchName: 'Head Office',
	},
	{
		value: 'FIRST_NATIONAL_BANK',
		label: 'First National Bank Zambia Ltd (FNB)',
		sortCode: '260005',
		beneficiaryCode: 'FIRNZMLX',
		branchName: 'FNB Head Office',
	},
	{
		value: 'UNITED_BANK_FOR_AFRICA',
		label: 'United Bank for Africa Zambia Ltd (UBA)',
		sortCode: '370001',
		beneficiaryCode: 'UNAFZMLU',
		branchName: 'Head Office',
	},
	{
		value: 'ZAMBIA_INDUSTRIAL_COMMERCIAL_BANK',
		label: 'Zambia Industrial Commercial Bank Plc (ZICB)',
		sortCode: '140202',
		beneficiaryCode: 'ZICBZMLU',
		branchName: 'Head Office',
	},
	{
		value: 'INVESTRUST_BANK',
		label: 'Investrust Bank Plc',
		sortCode: '170099',
		beneficiaryCode: 'VSTRZMLU',
		branchName: 'Investrust Bank Head Office',
	},
	{
		value: 'NATSAVE',
		label: 'National Savings and Credit Bank (NATSAVE)',
		sortCode: '582836',
		beneficiaryCode: 'NSCBZMLX',
		branchName: 'Head Office',
	},
	{
		value: 'BARCLAYS',
		label: 'Barclays Bank Zambia Ltd',
		sortCode: '020210',
		beneficiaryCode: 'BARCZMLX',
		branchName: 'Head Office',
	},
];

export const BENEFICIARY_CODE_OPTIONS = [
	{ label: 'BARCZMLX (Absa Bank Zambia Ltd)', value: 'BARCZMLX' },
	{
		label: 'ZNCOZMLU (Zambia National Commercial Bank)',
		value: 'ZNCOZMLU',
	},
	{ label: 'SBICZMLX (Stanbic Bank Zambia Ltd)', value: 'SBICZMLX' },
	{ label: 'INZAZMLX (Indo‑Zambia Bank Ltd)', value: 'INZAZMLX' },
	{
		label: 'SCBLZMLX (Standard Chartered Bank Zambia Plc)',
		value: 'SCBLZMLX',
	},
	{ label: 'AZAMZMLU (Access Bank Zambia Ltd)', value: 'AZAMZMLU' },
	{ label: 'ECOCZMLU (Ecobank Zambia Ltd)', value: 'ECOCZMLU' },
	{
		label: 'FALLZMLU (First Alliance Bank Zambia Ltd)',
		value: 'FALLZMLU',
	},
	{
		label: 'FRCGZMLU (First Capital Bank Zambia Ltd)',
		value: 'FRCGZMLU',
	},
	{
		label: 'FIRNZMLX (First National Bank Zambia Ltd)',
		value: 'FIRNZMLX',
	},
	{
		label: 'UNAFZMLU (United Bank for Africa Zambia Ltd)',
		value: 'UNAFZMLU',
	},
	{
		label: 'ZICBZMLU (Zambia Industrial Commercial Bank Plc)',
		value: 'ZICBZMLU',
	},
	{ label: 'VSTRZMLU (Investrust Bank Plc)', value: 'VSTRZMLU' },
	{ label: 'NSCBZMLX (National Savings and Credit Bank)', value: 'NSCBZMLX' },
	{ label: 'BARCZMLX (Barclays Bank Zambia Ltd)', value: 'BARCZMLX' },
];

export const monthOptions = [
	{ value: 1, label: 'January' },
	{ value: 2, label: 'February' },
	{ value: 3, label: 'March' },
	{ value: 4, label: 'April' },
	{ value: 5, label: 'May' },
	{ value: 6, label: 'June' },
	{ value: 7, label: 'July' },
	{ value: 8, label: 'August' },
	{ value: 9, label: 'September' },
	{ value: 10, label: 'October' },
	{ value: 11, label: 'November' },
	{ value: 12, label: 'December' },
];
